'use client';

import { IconId, ItemShape, Text, type TextColor } from '@stone-payments/jade';
import { Fragment } from 'react';

export type OrderStatusStep = {
  label: string;
  icon: IconId;
  status: 'completed' | 'current' | 'next';
};

export type OrderStatusTrackerProps = {
  steps: OrderStatusStep[];
};

const LABEL_COLOR_BY_STATUS = {
  completed: 'medium',
  current: 'high',
  next: 'low',
};

const DASHED_LINE =
  '[mask-image:repeating-linear-gradient(90deg,#000_0_4px,transparent_4px_10px)]';

export function OrderStatusTracker({ steps }: OrderStatusTrackerProps) {
  return (
    <div className="flex w-full items-start">
      {steps.map((step, index) => {
        const isNext = step.status === 'next';
        const nextStep = steps[index + 1];

        return (
          <Fragment key={step.label}>
            <div className="flex w-16 flex-col items-center gap-jade-100">
              <div className={isNext ? 'opacity-40' : undefined}>
                <ItemShape size="small" variant="neutral" use={step.icon} />
              </div>
              <Text
                variant="text-medium"
                weight="medium"
                color={LABEL_COLOR_BY_STATUS[step.status] as TextColor}
                className="text-center"
              >
                {step.label}
              </Text>
            </div>
            {nextStep && (
              <div
                aria-hidden
                className={`mt-5 flex-1 scale-y-[0.35] border-t border-solid border-jade-border-medium ${
                  nextStep.status === 'next' ? DASHED_LINE : ''
                }`}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
